<template id="team-challenge-cards">
    <ChallengeSectionContainer title="Team Challenges"
                               tooltipText="Lose the greatest percentage weight as a team of 5 and win $10,000 for 1st, $5,000 for 2nd and $3,000 for 3rd."
                               v-bind:isBigContainer="isBigContainer"
                               v-bind:key="challengeList.length" >
        <ChallengeCard v-for="challenge in challengeList"
                       v-bind:key="challenge.id"
                       class="team-challenge"
                       v-bind:isBigContainer="isBigContainer"
                       v-bind:src="challenge.challenge_image"
                       v-bind:title="challenge.challenge_name"
                       v-bind:subtitle="getSubtitle(challenge)"
                       v-bind:type="getType(challenge)"
                       v-bind:prizeValue="getPrizeValue(challenge)"
                       v-bind:betValue="getBetValue(challenge)"
                       v-bind:teamSize="getTeamSize(challenge)"
                       v-bind:dateRange="dateRangeOf(challenge)"
                       v-bind:signUpUrl="challenge.challenge_landing_page" />
    </ChallengeSectionContainer>
</template>

<script>
import GeneralChallengeCards from './GeneralChallengeCards';
import ChallengeSectionContainer from './card/ChallengeSectionContainer';
import ChallengeCard from './card/ChallengeCard';
import * as Currency from '../../../../static/js/currency'

export default {
  template: '#team-challenge-cards',
  mixins: [GeneralChallengeCards],
  components: { ChallengeSectionContainer, ChallengeCard },
  data: function() {
    return {
      challengeType: 'team'
    }
  },
  methods: {
    getPrizeValue: function (challenge) {
      var currency = Currency.HW.currency.getSymbol(challenge.prize.first_prize_currency);
      var value = isInt(challenge.prize.first_prize) ? challenge.prize.first_prize : parseFloat(challenge.prize.first_prize.toFixed(2));

      return currency.concat(value.toLocaleString(), ' top prize!');
    }
  }
}

function isInt(value) {
  return value % 1 === 0
}
</script>
